import { I18n, lang } from "config/config-general";

const storageKey = "forsler-guest-language";

function supportedLanguage(value: string | null | undefined): I18n | undefined {
  const code = value?.toLowerCase().split(/[-_]/)[0];
  // Browsers commonly identify Norwegian as Bokmål or Nynorsk.
  const normalized = code === "nb" || code === "nn" ? "no" : code;
  return lang.find(language => language === normalized);
}

export function getGuestLanguage(fallback: I18n = "en"): I18n {
  try {
    const saved = supportedLanguage(window.localStorage.getItem(storageKey));
    if (saved) return saved;
  } catch { /* Browser storage may be unavailable. */ }
  const preferences = navigator.languages?.length ? navigator.languages : [navigator.language];
  for (const preference of preferences) {
    const supported = supportedLanguage(preference);
    if (supported) return supported;
  }
  return fallback;
}

export function saveGuestLanguage(language: I18n): void {
  try { window.localStorage.setItem(storageKey, language); }
  catch { /* The language can still be changed for this session. */ }
}
